module.exports = __webpack_public_path__ + "img/home_2.cd402f73.svg";